import Rules from './Rules';
import Validator from './Validator';

/**
 * Object that contains our apps validation rules
 */
export default {
	emailAddress: new Validator('emailAddress',
		new Rules()
		.required('err:emailRequired')
		.email('err:emailValid')
		.maxLength('err:emailMaxLength', 100)
		.done()
	),
	firstName: new Validator('firstName',
		new Rules()
		.required('err:firstNameRequired')
		.maxLength('err:firstNameMaxLength', 100)
		.done()
	),
	lastName: new Validator('lastName',
		new Rules()
		.required('err:lastNameRequired')
		.maxLength('err:lastNameMaxLength', 50)
		.done()
	),
	password: new Validator('password',
		new Rules()
		.required('err:passwordRequired')
		.minLength('err:passwordMinLength', 6)
		.done()
	),
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/validation/Schema.js